import { memo } from "react";

/**
 * Loading skeleton component for hash keys list
 */
const HashKeysLoadingSkeleton = memo(() => (
  <div className="w-full overflow-hidden rounded-lg">
    {/* Header skeleton */}
    <div className="flex h-[52px] items-center gap-4 rounded-t-lg bg-gray-100 px-5 py-2">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="h-10 w-10 animate-pulse rounded-full bg-gray-300" />
        <div className="h-3 w-16 animate-pulse rounded bg-gray-300" />
      </div>
      <div className="h-3 w-20 animate-pulse rounded bg-gray-300" />
      <div className="h-3 w-16 animate-pulse rounded bg-gray-300" />
      <div className="h-3 w-12 animate-pulse rounded bg-gray-300" />
    </div>

    {/* Row skeletons */}
    <div className="flex flex-col gap-3">
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="flex h-[76px] items-center gap-4 rounded-lg border border-gray-200 bg-white p-5"
        >
          <div className="h-4 w-4 animate-pulse rounded bg-gray-300" />
          <div className="flex min-w-0 flex-1 items-center gap-3">
            <div className="relative h-10 w-10 flex-shrink-0">
              <div className="h-10 w-10 animate-pulse rounded-full bg-gray-300" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="h-4 w-32 animate-pulse rounded bg-gray-300" />
            </div>
          </div>
          <div className="h-4 w-48 animate-pulse rounded bg-gray-300" />
          <div className="h-5 w-16 animate-pulse rounded bg-gray-300" />
          <div className="flex gap-2">
            <div className="h-6 w-12 animate-pulse rounded bg-gray-300" />
            <div className="h-6 w-16 animate-pulse rounded bg-gray-300" />
          </div>
        </div>
      ))}
    </div>
  </div>
));

HashKeysLoadingSkeleton.displayName = "HashKeysLoadingSkeleton";

export default HashKeysLoadingSkeleton;
